import { render } from "./GeneralDonutCard.vue?vue&type=template&id=5a9614d9&ts=true"
import script from "./GeneralDonutCard.vue?vue&type=script&lang=ts"
export * from "./GeneralDonutCard.vue?vue&type=script&lang=ts"

import "./GeneralDonutCard.vue?vue&type=style&index=0&id=5a9614d9&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__